import React, { FC, useEffect, useState } from 'react';

import { Accordion } from '@material-ui/core';

import { IEventEnrollment } from '../../../../../../store/admin/eventEnrollments/store';
import { IAdminFlight } from '../../../../../../store/admin/eventFlights/store';
import { ITeam } from '../../../../../../store/admin/eventTeams/store';

import { useBoolean } from '../../../../../common/Hooks/useBoolean.hook';
import FlightItemSummary from './Components/FlightItemSummary/FlightItemSummary';
import FlightItemDetails from './Components/FlightItemDetails';

export interface IProps {
  item: IAdminFlight;
  type: 'team' | 'player';
  enrollments: IEventEnrollment[] | ITeam[];
  onToggle?: (event: any, expanded: boolean) => void;
}

const FlightItem: FC<IProps> = props => {
  const { item, onToggle, type, enrollments } = props;

  const [showListValue, setShowList] = useState(false);
  const [expanded, , toggleExpanded] = useBoolean(false);

  useEffect(() => {
    setTimeout(() => setShowList(true), 1500);

    return () => {
      setShowList(false);
    };
  }, []);

  return (
    <Accordion
      className="panel"
      onChange={enrollments.length ? onToggle : undefined}
      expanded={expanded}
      disabled={!showListValue}
    >
      <FlightItemSummary
        enrollments={enrollments}
        item={item}
        toggleExpanded={toggleExpanded}
        type={type}
      />

      <FlightItemDetails enrollments={enrollments} showListValue={showListValue} />
    </Accordion>
  );
};

export default FlightItem;
